import React, { Fragment } from 'react'
import LostPasswordTabset from './LostPasswordTabset';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ToastContainer  } from 'react-toastify';


const LostPassword = () => {
    return (
        <Fragment>
            <div className="page-wrapper">
                <div className="authentication-box">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3 p-0 card-left">
                            </div>
                            <div className="col-md-6 p-0 card-right">
                                <div className="card tab2-card">
                                    <div className="card-body">
                                        <LostPasswordTabset />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 p-0 card-left">   
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer/>
        </Fragment>
    )
}

export default LostPassword
